import { render, staticRenderFns } from "./boothInfo.vue?vue&type=template&id=8628f45e&scoped=true"
import script from "./boothInfo.vue?vue&type=script&lang=js"
export * from "./boothInfo.vue?vue&type=script&lang=js"
import style0 from "./boothInfo.vue?vue&type=style&index=0&id=8628f45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8628f45e",
  null
  
)

export default component.exports